import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import updateWorkoutAction from '../update'
import WORKOUTS_ACTION from '../../constants/action'

function updateNameWorkoutAction (name, workout) {
  return updateWorkoutAction({
    type: WORKOUTS_ACTION.UPDATE_NAME,
    payload: {
      key: WORKOUT_KEY.NAME,
      value: name,
      workout
    }
  })
}

export default updateNameWorkoutAction
